export default __webpack_public_path__ + "static/SSSpyView_screenshot-3-a185138770249541886f0a108c3c8d8a.webp";